"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TimeoutError = (function () {
    function TimeoutError(message) {
        message = message || 'The request timed out';
        this.message = message;
    }
    Object.defineProperty(TimeoutError.prototype, "name", {
        get: function () {
            return 'TimeoutError';
        },
        enumerable: true,
        configurable: true
    });
    return TimeoutError;
}());
exports.default = TimeoutError;


//////////////////
// WEBPACK FOOTER
// ./~/@dojo/core/request/TimeoutError.js
// module id = 21
// module chunks = 0